<template>
  <div id="pageTable" class="mainView">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-btn color="primary" dark slot="activator" @click="sendingSMS">SMS전송</v-btn>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <div class="flex xs12 sm2">
              <v-select
                :items="[{
                          text: '기사 고유번호',
                          value: 'id'
                        },
                        {
                          text: '전화번호',
                          value: 'phoneNumber'
                        },
                        {
                          text: '이름',
                          value: 'name'
                        },
                        {
                          text: '소속',
                          value: 'driverType'
                        },
                        {
                          text: '회사명',
                          value: 'company'
                        },
                        {
                          text: '사용상태',
                          value: 'state'
                        }]"
                name="header"   
                v-model="searchFormModel.filter"        
                label="header"
              ></v-select>
              </div>

              <div class="flex xs12 sm2" v-show="searchFormModel.filter === 'driverType'">
                <v-select
                        :items="[{
                            text: 'PERSONAL',
                            value: 'PERSONAL'
                          },
                          {
                            text: 'COMPANY',
                            value: 'COMPANY'
                          }]"
                        single-line
                        label="선택"
                        v-model="searchFormModel.filterText"
                ></v-select>
              </div>

              <div class="flex xs12 sm2" v-show="searchFormModel.filter === 'state'">
                <v-select
                        :items="state"
                        label="선택"
                        item-text="text"
                        item-value="state"
                        single-line
                        v-model="searchFormModel.filterText"
                >
                </v-select>
              </div>

              <v-text-field
                      v-show="searchFormModel.filter !== 'state' && searchFormModel.filter !== 'driverType'"
                      flat
                      solo
                      prepend-icon="search"
                      placeholder="Type something"
                      v-model="searchFormModel.filterText"
                      hide-details
                      class="hidden-sm-and-down"
                      @keyup.enter="searchFilter"
              ></v-text-field>
              <v-btn icon @click="searchFilter">
                <v-icon>filter_list</v-icon>
              </v-btn>         
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="complex.items"
                :rows-per-page-items="[10,25,50]"
                :total-items="totalItems"
                :pagination.sync="pagination"
                class="elevation-1"
                item-key="id"
                must-sort
                select-all
                v-model="complex.selected"
                >
                <template slot="items" slot-scope="props">
                  <td>
                    <v-checkbox
                      primary
                      hide-details
                      v-model="props.selected"
                    ></v-checkbox>
                  </td>
                  <td class="text-sm-center"><a @click="openDetail(props.item.id)">{{ props.item.id }}</a></td>
                  <td class="text-sm-center" >{{ props.item.name }}</td>
                  <td class="text-sm-center" >{{ props.item.birthDay }}</td>
                  <td class="text-sm-center" >{{ props.item.gender === 'M' ? '남자' : '여자' }}</td>
                  <td class="text-sm-center" >{{ props.item.phoneNumber }}</td>
                  <td class="text-sm-center" >{{ props.item.driverType }}</td>
                  <td class="text-sm-center" >{{ props.item.companyName }}</td>
                  <td class="text-sm-center" >{{ props.item.taxiNum }}</td>
                  <td class="text-sm-center" >{{ props.item.carModelName }}</td>
                  <td class="text-sm-center" >{{ props.item.businessNumber }}</td>
                  <td class="text-sm-center" >{{ props.item.regDate }}</td>
                  <td class="text-sm-center">
                    <v-select
                      :items="state"
                      label="State"
                      item-text="text"
                      item-value="state"
                      single-line
                      :value="props.item.state"
                      @change="changeState(props.item.id, $event)">
                    </v-select>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import State  from '@/api/state';

export default {
  components: {
    VWidget
  },
  data () {
    return {
      pagination: {
        sortBy: 'id',
        descending: true,
        rowsPerPage: 10,
        page: 1
      },
      searchFormModel: {
        filter: 'id',
        filterText: ''
      },
      totalItems: 0,
      loading: true,
      prevData: null,
      complex: {
        selected: [],
        headers: [
          {
            text: '기사 고유번호',
            value: 'id',
            align: 'center'
          },
          {
            text: '이름',
            value: 'name',
            sortable: false,
            align: 'center'
          },
          {
            text: '생년월일',
            value: 'birthDay',
            sortable: false,
            align: 'center'
          },
          {
            text: '성별',
            value: 'gender',
            sortable: false,
            align: 'center'
          },
          {
            text: '휴대전화번호',
            value: 'phoneNumber',
            align: 'center'
          },
          {
            text: '소속',
            value: 'driverType',
            align: 'center'
          },
          {
            text: '회사명',
            value: 'companyName',
            align: 'center'
          },
          {
            text: '차량번호',
            value: 'taxiNum',
            sortable: false,
            align: 'center'
          },
          {
            text: '차량모델명',
            value: 'carModelName',
            sortable: false,
            align: 'center'
          },
          {
            text: '개인사업자번호(운수사번)',
            value: 'businessNumber',
            sortable: false,
            align: 'center'
          },
          {
            text: '가입일',
            value: 'regDate',
            align: 'center'
          },
          {
            text: '사용 상태',
            value: 'state',
            align: 'center'
          },
        ],
        items: []
      },
      state: State
    };
  },
  watch: {
    pagination: {
      handler () {
        if (top.getApp.prevPageName === 'DriverMemberPage') {
          if(top.getApp.prevPagination != null) {
            this.pagination = top.getApp.prevPagination;
          }

          if(top.getApp.prevSearchFormModel != null) {
            this.searchFormModel = top.getApp.prevSearchFormModel;
          }

          top.getApp.clearPrevData();
        }

        this.banbanCreated();
      },
      deep: true
    },
    'searchFormModel.filter' () {
        this.searchFormModel.filterText = '';
    }
  },
  mounted () {
    for (let i = 0; i < this.$parent.$children.length; i++) {
      if (this.$parent.$children[i].chkAutoReload != null) {
        this.$parent.$children[i].chkAutoReload();
      }
    }
  },
  methods: {
    banbanCreated () {
      this.loading = true;

      const parameters = {
        method: 'searchDrivers',
        pageNum: this.pagination.page - 1,
        pageSize: this.pagination.rowsPerPage,
        sortName: this.pagination.sortBy,
        order: this.pagination.descending == true ? 'desc' : 'asc',
        filter: this.searchFormModel.filter,
        filterText: this.searchFormModel.filterText
      };
      this.$store.dispatch('banbanAPI', parameters)
        .then(({ data }) => {
          if (data.statusCode != null && data.statusCode != '200'){
            throw data.message;
          }

          this.complex.items = data.content;
          this.totalItems = data.totalElements;
          this.loading = false;
          top.getApp.progress.dialog = false;
        })
        .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
          top.getApp.progress.dialog = false;
        });
    },
    changeState (id, state) {
      const prameters = {
        method: 'changeState',
        'id': id,
        'userState': state
      };
      this.$store.dispatch('banbanAPI', prameters)
        .then(({ data }) => {
          top.getApp.progress.dialog = false;
        })
        .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
          top.getApp.progress.dialog = false;
        });
    },
    openDetail (id) {
      top.getApp.addPrevData('DriverMemberPage', this.pagination, this.searchFormModel);
      this.$router.push('/member/driverMemberDetail/' + id);
    },
    searchFilter () {
      this.banbanCreated();
    },
    sendingSMS () {
      if (localStorage.role === 'DRIVER_ADMIN') {
        alert('권한이 없습니다.');
        return;
      } else if (this.complex.selected.length === 0) {
        alert('SMS 전송할 대상을 선택하세요');
        return;
      } else if (this.complex.selected.length >= 1000) {
        alert('최대 1000명까지 동시에 전송할 수 있습니다.');
        return;
      }

      let phoneNumber = this.complex.selected[0].phoneNumber;
      for(let i = 1, size = this.complex.selected.length; i < size; i++) {
        phoneNumber += ',' + this.complex.selected[i].phoneNumber;
      }

      top.getApp.addPrevData('DriverMemberPage', this.pagination, this.searchFormModel);
      this.$router.push('/sms/sendingSMS/' + phoneNumber);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/member/DriverMember.vue